import { Attribution } from '@mui/icons-material';
import { type ReactElement } from 'react';

import { type PopupType } from '@/types';

import { userAccessRoutes } from './userAccessRoutes';

const USER_ACCESS_CONTROL_FEATURE = 'user_access_control';

export function getUserAccessControlPopupDefs(element: ReactElement) {
  return [
    {
      title: 'mainMenu.userAccessControl',
      icon: <Attribution fontSize="small" />,
      element,
      showToken: false,
      mainFunction: true,
      showMobile: true,
      level: 1,
      path: userAccessRoutes.root,
      activeOnSubRoutes: true,
      requiredExtraFeature: USER_ACCESS_CONTROL_FEATURE,
      dataQaElementId: 'more-list-item-user-access-control',
    },
    {
      element,
      showToken: false,
      mainFunction: true,
      showMobile: false,
      level: 1,
      path: userAccessRoutes.userDetailsPattern,
      hidden: true,
      requiredExtraFeature: USER_ACCESS_CONTROL_FEATURE,
    },
    {
      element,
      showToken: false,
      mainFunction: true,
      showMobile: false,
      level: 1,
      path: userAccessRoutes.userFormPattern,
      hidden: true,
      requiredExtraFeature: USER_ACCESS_CONTROL_FEATURE,
    },
  ] satisfies PopupType[];
}
